import Cleave from 'cleave.js'
import { CleaveOptions } from 'cleave.js/options'
import * as React from 'react'

import {
  CleaveInput,
  Container,
  FieldContainer,
  Input,
  Label,
  ValidationHint,
} from './BaseTextField.styles'
import { ITextFieldProps } from './types'

interface IProps extends ITextFieldProps {
  cleaveOptions?: CleaveOptions
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

interface IState {
  active: boolean
  focused: boolean
}

export const defaultTextFieldProps = {
  autoFocus: false,
  disabled: false,
  invalid: false,
  required: false,
}

export default class BaseTextField extends React.Component<IProps, IState> {
  public static defaultProps = {
    ...defaultTextFieldProps,
  }

  public state = {
    active: this.props.value.length > 0,
    focused: false,
  }

  public render() {
    const { disabled, validationHint, label, roundedCorners } = this.props
    const { active, focused } = this.state

    return (
      <Container>
        <FieldContainer
          disabled={disabled}
          focused={focused}
          invalid={this.invalid}
          roundedCorners={roundedCorners}
        >
          {label && (
            <Label active={active} focused={focused} invalid={this.invalid}>
              {label}
            </Label>
          )}

          {this.renderInput()}
        </FieldContainer>

        {validationHint && <ValidationHint>{validationHint}</ValidationHint>}
      </Container>
    )
  }

  private renderInput() {
    const {
      autoComplete,
      autoCapitalize,
      cleaveOptions,
      disabled,
      label,
      pattern,
      placeholder,
      type,
      value,
      roundedCorners,
    } = this.props
    const { active, focused } = this.state

    const props = {
      autoComplete,
      autoCapitalize,
      disabled,
      hasLabel: !!label && (active || focused || this.invalid),
      onBlur: this.handleBlur,
      onChange: this.handleChange,
      onFocus: this.handleFocus,
      pattern,
      placeholder: focused || this.invalid ? placeholder : this.restPlaceholder,
      type,
      value,
      roundedCorners,
    }

    return cleaveOptions ? (
      <CleaveInput
        {...props}
        options={cleaveOptions}
        onInit={self => {
          this.handleCleaveInit(self as unknown as Cleave, value)
        }}
      />
    ) : (
      <Input {...props} />
    )
  }

  private handleCleaveInit = (cleave: Cleave, value: string) => {
    // if initial value is supplied, make sure it is formatted
    if (!!value) {
      cleave.setRawValue(value)
    }
  }

  private handleBlur = () => {
    this.setState({ active: !!this.props.value && this.props.value.length > 0, focused: false })
    if (this.props.onBlur) this.props.onBlur()
  }

  private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.onChange(event)
  }

  private handleFocus = () => {
    this.setState({ focused: true })
  }

  private get invalid() {
    return this.props.invalid || !!this.props.validationHint
  }

  private get restPlaceholder() {
    const { label, placeholder, required } = this.props
    const placeholderText: string = label || placeholder

    return `${placeholderText}${required ? '*' : ''}`
  }
}
